import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Code2 } from "lucide-react";
import { CONTACT, EKTIREN, waLink } from "@/data/site";

export default function FloatingActions() {
  const [showEktiren, setShowEktiren] = useState(true);

  return (
    <>
      {/* WhatsApp floating (bottom-right) */}
      <a
        href={waLink(CONTACT.phoneRaw, "Merhaba İzmir Medya, sosyal medya paketleriniz hakkında bilgi almak istiyorum.")}
        target="_blank" rel="noreferrer"
        data-testid="floating-whatsapp"
        className="fixed bottom-5 right-5 z-[60] flex items-center gap-2 pl-4 pr-5 py-3.5 rounded-full bg-green-500 text-white font-semibold shadow-2xl shadow-green-500/40 hover:scale-105 transition-transform"
      >
        <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-40 animate-ping" />
        <MessageCircle className="w-5 h-5 relative" />
        <span className="relative hidden sm:inline">WhatsApp</span>
      </a>

      {/* Ektiren Project badge (bottom-left) */}
      <AnimatePresence>
        {showEktiren && (
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -40 }}
            transition={{ delay: 1.2, duration: 0.6 }}
            data-testid="ektiren-floating-badge"
            className="fixed bottom-5 left-5 z-[60] flex items-center"
          >
            <a
              href={waLink(EKTIREN.phoneRaw, "Merhaba Ektiren Project, web sitesi yaptırmak istiyorum.")}
              target="_blank" rel="noreferrer"
              className="neon-border glass-strong group flex items-center gap-2.5 pl-3 pr-4 py-2.5 rounded-full"
            >
              <span className="grid place-items-center w-7 h-7 rounded-full bg-gradient-to-br from-cobalt to-neon-purple">
                <Code2 className="w-3.5 h-3.5 text-white" />
              </span>
              <span className="text-xs leading-tight">
                <span className="block text-slate-400 font-mono">Powered by</span>
                <span className="block font-display font-bold text-white group-hover:text-gradient">Ektiren Project</span>
              </span>
            </a>
            <button
              onClick={() => setShowEktiren(false)}
              aria-label="Kapat"
              className="ml-1 p-1 text-slate-500 hover:text-white"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
